import { StyleSheet } from 'react-native';
import { pt, px } from '../common/utils';

export default StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: '#fff',
        height: '100%'
    },
    wrap: {
        flex: 1
    },
    selected: {
        backgroundColor: '#fff'
    },
    // 时间筛选
    date_selected: {
        borderBottomWidth: px(1),
        borderBottomColor: 'rgba(0,0,0,0.1)',
        height: pt(38)
    },
    date_item_wrap: {
        paddingHorizontal: pt(11),
        paddingTop: pt(11)
    },
    date_wrap: {
        paddingBottom: pt(9),
        borderBottomWidth: pt(2),
        borderBottomColor: '#fff',
        height: pt(26)
    },
    cur_data_wrap: {
        borderBottomColor: '#E2231A'
    },
    date_selected_item: {
        fontSize: pt(12),
        fontWeight: 'bold',
        color: '#898989'
    },
    cur_data_item: {
        color: '#E2231A'
    },
    // 影院列表
    cinema_item: {
        paddingVertical: pt(12),
        borderBottomWidth: px(1),
        borderBottomColor: 'rgba(0,0,0,0.1)'
    },
    cinema_common: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingRight: pt(18),
        paddingLeft: pt(15)

    },
    cinema_name_wrap: {
        height: pt(22),
        marginBottom: pt(4)
    },
    cinema_name: {
        fontSize: pt(16),
        width: pt(270)
    },
    cinema_price_wrap: {
        fontSize: pt(14),
        color: '#898989'
    },
    cinema_price: {
        color: '#E2231A',
        fontSize: pt(16)
    },
    cinema_address_wrap: {
        height: pt(18)
    },
    cinema_address: {
        color: '#898989',
        fontSize: pt(12),
        width: pt(270)
    },
    cinema_km: {
        color: '#898989',
        fontSize: pt(13)
    },
    show_time_out: {
        marginTop: pt(8)
    },
    show_time_wrap: {
        color: '#898989',
        fontSize: pt(12),
        paddingLeft: pt(15)
    },
    show_time: {
        fontWeight: 'bold'
    },
    cinema_been: {
        position: 'absolute',
        height: pt(24),
        width: pt(24),
        right: 0
    },
    // 促销
    v_tip: {
        flexDirection: 'row',
        alignItems: 'center',
        paddingLeft: pt(15),
        marginTop: pt(6)
    },
    tip: {
        height: pt(15),
        width: pt(14),
        borderRadius: pt(2),
        justifyContent: 'center',
        alignItems: 'center',
        marginRight: pt(5),
        backgroundColor: '#F56A00'
    },
    scale: {
        fontSize: pt(10),
        color: '#fff'
    },
    i_text: {
        color: 'rgba(0,0,0,.45)',
        fontSize: pt(12)
    },

    dialog: {
        padding: pt(20)
    },
    dialog_txt: {
        fontSize: pt(15)
    },
    gray: {
        color: '#898989'
    },
    
    offten_wrap: {
        marginTop: pt(10)
    },
    offten_go_wrap: {
        height: pt(70),
        paddingLeft: pt(10)
    },
    offten_go_item: {
        position: 'relative',
        height: pt(70),
        width: pt(72),
        marginRight: pt(10),
        // paddingLeft: pt(14),
        backgroundColor: '#F5F7F8',
        borderRadius: pt(3),
        justifyContent: 'center',
        alignItems: 'center',
        // alignItems: 'flex-start',
        borderWidth: px(1),
        borderColor: '#E6E8E9'
    },
    offten_go_time: {
        color: '#252525',
        fontSize: pt(16)
    },
    offten_go_type: {
        color: '#898989',
        fontSize: pt(10)
    },
    offten_go_priceRise: {
        fontSize: pt(10),
        color: '#999999'
    },
    offten_go_price: {
        color: '#E2231A',
        fontSize: pt(12)
    },
    offten_next_day_wrap: {
        position: 'absolute',
        top: 0,
        left: 0
    },
    offten_next_day: {
        height: pt(13),
        width: pt(19)
    },

    // 底部定位
    position_wrap: {
        height: pt(30),
        backgroundColor: '#F5F7F8',
        borderTopColor: '#E6E8E9',
        borderTopWidth: pt(1),
        flexDirection: 'row',
        alignItems: 'center'
    },
    reload: {
        height: pt(30),
        paddingHorizontal: pt(10),
        justifyContent: 'center'
    },
    position_city: {
        flexDirection: 'row',
        alignItems: 'center'
    },
    now_city: {
        fontSize: pt(12),
        color: '#666666',
        maxWidth: pt(340),
        backgroundColor: 'transparent'
    },
    now_dif_city: {
        maxWidth: pt(210)
    },
    text_style: {
        fontSize: pt(12),
        color: '#666666',
        marginLeft: pt(10),
        backgroundColor: 'transparent'
    },
    check_city: {
        height: pt(30),
        paddingHorizontal: pt(10),
        justifyContent: 'center',
        alignItems: 'center'
    },
    switch_city: {
        color: 'red',
        fontSize: pt(12),
        backgroundColor: 'transparent'
    },
    reload_img: {
        width: pt(12),
        height: pt(11)
    },
    loaction_txt: {
        color: 'red'
    },
    governmentSubsidyContainer: {
        borderRadius: pt(2),
        marginTop: pt(10),
        marginLeft: pt(15),
        flexDirection: 'row',
        backgroundColor: '#F0FAF4',
        height: pt(14),
        borderWidth: pt(0.5),
        borderStyle: 'solid',
        borderColor: '#BDDFBF',
        position: 'relative',
        alignSelf: 'flex-start',
        paddingRight: pt(3),
    },
    governmentSubsidyDiscounts: {
        height: pt(14.5),
        width: pt(14.5),
        textAlign: 'center',
        lineHeight: pt(15),
        borderRadius: pt(2),
        backgroundColor: '#0AAD48',
        fontSize: pt(10),
        color: '#FFFFFF',
        position: 'absolute',
        left: -pt(0.5),
        top: -pt(0.5),
        zIndex: 1,
    },
    governmentSubsidyContent: {
        marginLeft: pt(18),
        fontSize: pt(10),
        color: '#0AAD48',
        
    }
});
